import { useAuth0 } from '@auth0/auth0-react'
import { useMemo } from 'react'
import { useProfileName } from '../../../hooks/useProfileName'
import { firstNameFromAuthUser, firstNameFromDisplayName } from '../../../utils/displayName'

export function useHomeGreetingName(enabled: boolean): string | null {
  const { user } = useAuth0()
  const profileName = useProfileName()

  const fallbackFirstName = useMemo(() => {
    return firstNameFromAuthUser(user)
  }, [user])

  const profileFirstName = enabled ? firstNameFromDisplayName(profileName.firstName) : null
  return profileFirstName ?? fallbackFirstName
}
